// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/Bg_graphic.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/Icons/mail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Assets/Icons/key.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-color: #FCF9F7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center;
    width: 100%;
    height: 100vh;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
    overflow: auto;
}

.Login_Card {
    width: 29%;
    padding: 40px;
    position: absolute;
    left: 50%;
    display: flex;
    min-width: 440px;
    flex-direction: column;
    /* flex-wrap: wrap; */
    gap: 40px;
    transform: translate(-50%, 92px);
    background: #FFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 0.5rem;
    max-height: 75vh;
}

.Login_Card::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.Login_Card::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.Login_Button button {
    width: 100%;
    padding: 0.4rem;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    background-color: #E67817;
    border-radius: 8px;
    border-color: transparent;
    font-weight: 500;
    font-size: 16px;
    color: #FFFF;
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}

.atom-animation {
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}

.atom-animation:hover {
    transform: scale(0.98);
}

.Login_Button>button:hover {
    transform: scale(0.98);
    background-color: #d0660a;
}

.Login_Title>span {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #3F3325;
}


.Login_Input input {
    border: 2px solid #E8DFD5;
    border-radius: 8px;
    width: 100%;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    padding: 0.6rem;
    background: #FFFF;
    line-height: 20px;
}


.Login_Input input:focus-visible {
    outline: none;
    border: 1px solid #9A938A;
    opacity: 1;
}

.login_button_disabled {
    cursor: no-drop !important;
    opacity: 0.3;
}

.input_warning {
    color: #D2281C !important;
    border: 1px solid #D2281C !important;
    opacity: 1 !important;
}

.Login_Input>#warning {
    color: #D2281C;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
}


.Login_Input {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.Login_Input>label {
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #594F42;
}

.Login_Input>.email_icon {
    display: inline-block;
    line-height: 20px;
    padding-left: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat scroll 0 0 transparent;
    background-position: left;
}

.Login_Input>.password_icon {
    display: inline-block;
    line-height: 20px;
    padding-left: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll 0 0 transparent;
    background-position: left;
}

.Login_Input>.password {
    position: relative;
    display: grid;
    align-items: center;
}

.Login_Input>.password>img {
    position: absolute;
    right: 12px;
    cursor: pointer;
}



.Login_Forgot>span {
    color: #2A78BF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
}

.Login_Forgot {
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
    cursor: pointer;
    width: fit-content;
}

.Login_Forgot:hover {
    transform: scale(0.98);
}

.Description {
    display: inline-block;
}

.Description>p {
    width: 100%;
    font-weight: 400;
    color: #594F42;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
}


.Password_conditions>p {
    font-weight: 400;
    font-size: 14px;
    color: #594F42;
}

.Password_conditions>ul {
    padding: 20px;
}

.Password_conditions>ul>li>span {
    font-weight: 400;
    font-size: 14px;
    color: #9A938A;
    line-height: 24px;
}

.spinner {
    /* background-color: #E8DFD5; */
    height: 40vh;
    width: 40vw;
    display: flex;
    align-items: center;
    justify-content: center;
}



.Otp {
    width: 84px !important;
    height: 80px !important;
    padding: 4px 12px 2px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid var(--grey-300);
    color: var(--grey-800);
    font-family: IBM Plex Sans Devanagari;
    font-size: 36px !important;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    letter-spacing: -0.72px;
    text-align: center;
    background: var(--base-white);
}

.OtpContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
}

.Otp::placeholder {
    color: grey
}`, "",{"version":3,"sources":["webpack://./src/CSS/Login.css"],"names":[],"mappings":"AAAA;IACI,6DAA4D;IAC5D,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,gDAAgD;IAChD,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,4EAA4E;AAChF;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,oFAA4E;IAC5E,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,oFAA2E;IAC3E,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;;;AAIA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,4EAA4E;IAC5E,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;;AAIA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iCAAiC;IACjC,sBAAsB;IACtB,qCAAqC;IACrC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI;AACJ","sourcesContent":[".Login {\n    background: url('../Assets/Images/Bg_graphic.png') no-repeat;\n    background-color: #FCF9F7;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-self: center;\n    width: 100%;\n    height: 100vh;\n    background-position: center center;\n    background-attachment: fixed;\n    background-size: cover;\n    overflow: auto;\n}\n\n.Login_Card {\n    width: 29%;\n    padding: 40px;\n    position: absolute;\n    left: 50%;\n    display: flex;\n    min-width: 440px;\n    flex-direction: column;\n    /* flex-wrap: wrap; */\n    gap: 40px;\n    transform: translate(-50%, 92px);\n    background: #FFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 0.5rem;\n    max-height: 75vh;\n}\n\n.Login_Card::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n\n.Login_Card::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n\n.Login_Button button {\n    width: 100%;\n    padding: 0.4rem;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 12px 16px;\n    gap: 12px;\n    background-color: #E67817;\n    border-radius: 8px;\n    border-color: transparent;\n    font-weight: 500;\n    font-size: 16px;\n    color: #FFFF;\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n.atom-animation {\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n.atom-animation:hover {\n    transform: scale(0.98);\n}\n\n.Login_Button>button:hover {\n    transform: scale(0.98);\n    background-color: #d0660a;\n}\n\n.Login_Title>span {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #3F3325;\n}\n\n\n.Login_Input input {\n    border: 2px solid #E8DFD5;\n    border-radius: 8px;\n    width: 100%;\n    height: 40px;\n    font-weight: 400;\n    font-size: 14px;\n    padding: 0.6rem;\n    background: #FFFF;\n    line-height: 20px;\n}\n\n\n.Login_Input input:focus-visible {\n    outline: none;\n    border: 1px solid #9A938A;\n    opacity: 1;\n}\n\n.login_button_disabled {\n    cursor: no-drop !important;\n    opacity: 0.3;\n}\n\n.input_warning {\n    color: #D2281C !important;\n    border: 1px solid #D2281C !important;\n    opacity: 1 !important;\n}\n\n.Login_Input>#warning {\n    color: #D2281C;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n}\n\n\n.Login_Input {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.Login_Input>label {\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #594F42;\n}\n\n.Login_Input>.email_icon {\n    display: inline-block;\n    line-height: 20px;\n    padding-left: 24px;\n    background: url(\"../Assets/Icons/mail.svg\") no-repeat scroll 0 0 transparent;\n    background-position: left;\n}\n\n.Login_Input>.password_icon {\n    display: inline-block;\n    line-height: 20px;\n    padding-left: 24px;\n    background: url(\"../Assets/Icons/key.svg\") no-repeat scroll 0 0 transparent;\n    background-position: left;\n}\n\n.Login_Input>.password {\n    position: relative;\n    display: grid;\n    align-items: center;\n}\n\n.Login_Input>.password>img {\n    position: absolute;\n    right: 12px;\n    cursor: pointer;\n}\n\n\n\n.Login_Forgot>span {\n    color: #2A78BF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: right;\n}\n\n.Login_Forgot {\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n    cursor: pointer;\n    width: fit-content;\n}\n\n.Login_Forgot:hover {\n    transform: scale(0.98);\n}\n\n.Description {\n    display: inline-block;\n}\n\n.Description>p {\n    width: 100%;\n    font-weight: 400;\n    color: #594F42;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n\n.Password_conditions>p {\n    font-weight: 400;\n    font-size: 14px;\n    color: #594F42;\n}\n\n.Password_conditions>ul {\n    padding: 20px;\n}\n\n.Password_conditions>ul>li>span {\n    font-weight: 400;\n    font-size: 14px;\n    color: #9A938A;\n    line-height: 24px;\n}\n\n.spinner {\n    /* background-color: #E8DFD5; */\n    height: 40vh;\n    width: 40vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n\n.Otp {\n    width: 84px !important;\n    height: 80px !important;\n    padding: 4px 12px 2px 12px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 8px;\n    border: 1px solid var(--grey-300);\n    color: var(--grey-800);\n    font-family: IBM Plex Sans Devanagari;\n    font-size: 36px !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 44px;\n    letter-spacing: -0.72px;\n    text-align: center;\n    background: var(--base-white);\n}\n\n.OtpContainer {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.Otp::placeholder {\n    color: grey\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
